import { appliesMeta } from '@/utils/functions/applies-meta'
import Projects from 'components/projects'
import Dashboards from 'components/dashboards'

export default appliesMeta({
  template: 'chameleon',
  requiresAuth: true
}, [
    {
      path: '/projects',
        component: Projects.Projects,
        name: 'projects.index',
    },
    {
      path: '/project-statuses',
        component: Dashboards.ProjectStatuses,
        name: 'projects.project-statuses',
    },
    {
      path: '/project/:project_id/stage1/:stage_id',
      component: Projects.Stage1,
        name: 'projects.stage1',
        meta: { hasSidebar: true },
        children: [
            {
            path: 'overview',
            component: Projects.Overview,
            name: 'projects.stage1.overview',
            },
            {
            path: ':user_story_doc_id/:sprint_id/deliverables',
            component: Projects.Deliverables,
                name: 'projects.stage1.deliverables',
                meta: { hideFooter: true, flex: true, hasSidebar: true },
                children: [
                    {
                        path: 'preview/:story_id',
                        name: 'projects.stage1.deliverables.preview',
                        component: Projects.StoryPreview,
                    },
                    {
                        path: ':story_id',
                        name: 'projects.stage1.deliverables.detail',
                        component: Projects.StoryDetail,
                        meta: { hideNav: true, hideFooter: true, fullPageModal: true },
                    },
                ]
            },
          {
            path: 'requirements',
            component: Projects.Requirements,
            name: 'projects.stage1.requirements',
            },
            {
            path: 'userstories',
            component: Projects.Userstories,
            name: 'projects.stage1.userstories',
            },
            {
            path: 'activity',
            component: Projects.ActivityLogList,
            name: 'projects.stage1.activity',
          }
        ]
    },
    {
      path: '/project/:project_id/stage2/:stage_id',
      component: Projects.Stage2,
        name: 'projects.stage2',
        meta: { hasSidebar: true },
        children: [
            {
            path: 'overview',
            component: Projects.Overview,
            name: 'projects.stage2.overview',
            },
            {
            path: ':user_story_doc_id/:sprint_id/deliverables',
            component: Projects.Deliverables,
                name: 'projects.stage2.deliverables',
                meta: { hideFooter: true, flex: true, hasSidebar: true },
                children: [
                    {
                        path: 'preview/:story_id',
                        name: 'projects.stage2.deliverables.preview',
                        component: Projects.StoryPreview,
                    },
                    {
                        path: ':story_id',
                        name: 'projects.stage2.deliverables.detail',
                        component: Projects.StoryDetail,
                        meta: { hideNav: true, hideFooter: true, fullPageModal: true },
                    },
                ]
            },
            {
            path: 'userstories',
            component: Projects.Userstories,
                name: 'projects.stage2.userstories',
            },
            {
            path: 'activity',
            component: Projects.ActivityLogList,
                name: 'projects.stage2.activity',
            },
            {
            path: 'costing',
            component: Projects.Costing,
                name: 'projects.stage2.costing',
          }
        ]
    },
    {
      path: '/project/:project_id/stage3/:stage_id',
      component: Projects.Stage3,
        name: 'projects.stage3',
        meta: { hasSidebar: true },
        children: [
            {
            path: 'overview',
            component: Projects.Overview,
            name: 'projects.stage3.overview',
            },
            {
            path: ':user_story_doc_id/:sprint_id/deliverables',
            component: Projects.Deliverables,
                name: 'projects.stage3.deliverables',
                meta: { hideFooter: true, flex: true, hasSidebar: true },
                children: [
                    {
                        path: 'preview/:story_id',
                        component: Projects.StoryPreview,
                        name: 'projects.stage3.deliverables.preview',
                    },
                    {
                        path: ':story_id',
                        component: Projects.StoryDetail,
                        name: 'projects.stage3.deliverables.detail',
                        meta: { hideNav: true, hideFooter: true, fullPageModal: true },
                    },
                ]
            },
            {
            path: ':user_story_doc_id/:sprint_id/scrum',
            component: Projects.ScrumBoard,
                name: 'projects.stage3.scrum',
                meta: { hideFooter: true, flex: true, hasSidebar: true },
                children: [
                    {
                        path: 'preview/:story_id',
                        component: Projects.StoryPreview,
                        name: 'projects.stage3.scrum.preview',
                    },
                    {
                        path: ':story_id',
                        component: Projects.StoryDetail,
                        name: 'projects.stage3.scrum.detail',
                        meta: { hideNav: true, hideFooter: true, fullPageModal: true },
                    },
                ]
            },
            {
              path: ':user_story_doc_id/:sprint_id/planner',
              component: Projects.SprintPlanner,
              name: 'projects.stage3.planner',
              meta: { hideFooter: true, flex: true, hasSidebar: true },
              children: [
                  {
                      path: 'preview/:story_id',
                      component: Projects.StoryPreview,
                      name: 'projects.stage3.planner.preview',
                  },
                  {
                      path: ':story_id',
                      component: Projects.StoryDetail,
                      name: 'projects.stage3.planner.detail',
                      meta: { hideNav: true, hideFooter: true, fullPageModal: true },
                  },
              ]
            },
            {
              path: ':user_story_doc_id/issueboard',
              component: Projects.IssueBoard,
              name: 'projects.stage3.issueboard',
              meta: { hideFooter: true, flex: true, hasSidebar: true }
            },
        ]
    },
    {
      path: '/projects/:project_id',
      component: Projects.Show,
      name: 'projects.show',
        children: [
          {
            path: 'details',
                component: Projects.Details,
                name: 'projects.show.details',
            },
          {
            path: 'stage1',
            component: Projects.Requirements,
            name: 'projects.show.stage1',
          },
            {
              path: 'stage2',
                component: Projects.Stage2,
                name: 'projects.show.stage2',
                children: [
                  {
                    path: 'userstories',
                    component: Projects.Userstories,
                    name: 'projects.show.stage2.userstories'
                  },
                  {
                    path: 'deliverables',
                    component: Projects.Deliverables,
                    name: 'projects.show.stage2.deliverables'
                  },
                ]
            },
            {
              path: 'stage3',
                component: Projects.Stage3,
                name: 'projects.show.stage3',
            },
        ]
    },
])
